import { SignUpPlanType } from '../../SignUp/Types/SignUp/SignUpPlan';
import { SignUpPerkType } from '../../SignUp/Types/SignUp/SignUpPerk';
import { SignUpLetterPlanType } from '../../SignUp/Types/SignUp/SignUpLetterPlan';
import { SignUpParcelPlanType } from '../../SignUp/Types/SignUp/SignUpParcelPlan';

export const PlansOverview: Array<SignUpPlanType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'PO Box',
		description: 'Basic blurb about typical use-case',
		cost: 0.0,
		variablePrice: false,
		perks: [0, 1, 2],
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'Street',
		cost: 12.0,
		description: 'Basic blurb about typical use-case',
		variablePrice: true,
		perks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
		tips: [9, 8, 7, 6, 5],
	},
	{
		id: 2,
		orderIndex: 2,
		enabled: true,
		label: 'Business',
		description: 'Same as street, but less options...',
		cost: 12.0,
		variablePrice: true,
		perks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
		tips: [9, 8, 7, 6],
	},
	{
		id: 3,
		orderIndex: 3,
		enabled: true,
		label: 'Parcel',
		description: 'Fulfilment, returns, etc.',
		cost: 0.0,
		variablePrice: false,
		perks: [6, 7, 8],
	},
	{
		id: 4,
		orderIndex: 4,
		enabled: true,
		label: 'Redirection',
		description: 'Redirect your mail only...',
		cost: 0.0,
		variablePrice: false,
		perks: [5],
	},
];

export const PlanPerks: Array<SignUpPerkType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'Personal Address',
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'Sole Trader Address',
	},
	{
		id: 2,
		orderIndex: 2,
		enabled: true,
		label: 'Business Trading Address',
	},
	{
		id: 3,
		orderIndex: 3,
		enabled: true,
		label: 'Registered Office Address',
	},
	{
		id: 4,
		orderIndex: 4,
		enabled: true,
		label: 'Directors Service Address',
	},
	{
		id: 5,
		orderIndex: 5,
		enabled: true,
		label: 'Royal Mailboxes Redirection (UK)',
	},
	{
		id: 6,
		orderIndex: 6,
		enabled: true,
		label: 'Online Shop and Ship',
	},
	{
		id: 7,
		orderIndex: 7,
		enabled: true,
		label: 'Customers Returns',
	},
	{
		id: 8,
		orderIndex: 8,
		enabled: true,
		label: 'Fulfilment and Drop-shipping',
	},
	{
		id: 9,
		orderIndex: 9,
		enabled: true,
		label: 'Google AdSense',
	},
];

export const PoBoxOverview: Array<SignUpPlanType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'Poole',
		labelExtra: '',
		cost: 0.0,
		variablePrice: false,
		perks: [0, 1, 2],
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'London',
		labelExtra: '',
		cost: 0.0,
		variablePrice: false,
		perks: [0, 1, 2],
	},
	{
		id: 2,
		orderIndex: 2,
		enabled: true,
		label: 'Manchester',
		labelExtra: '',
		cost: 0.0,
		variablePrice: false,
		perks: [0, 1, 2],
	},
	{
		id: 3,
		orderIndex: 3,
		enabled: true,
		label: 'Birmingham',
		labelExtra: '',
		cost: 0.0,
		variablePrice: false,
		perks: [0, 1, 2],
	},
	{
		id: 4,
		orderIndex: 4,
		enabled: true,
		label: 'Cardiff',
		labelExtra: '',
		cost: 0.0,
		variablePrice: false,
		perks: [0, 1, 2],
	},
	{
		id: 5,
		orderIndex: 5,
		enabled: true,
		label: 'Glasgow',
		labelExtra: '',
		cost: 0.0,
		variablePrice: false,
		perks: [0, 1, 2],
	},
	{
		id: 6,
		orderIndex: 6,
		enabled: true,
		label: 'Belfast',
		labelExtra: '',
		cost: 0.0,
		variablePrice: false,
		perks: [0, 1, 2],
	},
];

export const StreetAddressesOverview: Array<SignUpPlanType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'Dorset',
		labelExtra: 'Poole (BH16)',
		cost: 12.0,
		variablePrice: false,
		perks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'London North',
		labelExtra: 'Palmers Green (N13)',
		cost: 18.0,
		variablePrice: false,
		perks: [0, 1, 2, 3, 4, 5],
	},
	{
		id: 2,
		orderIndex: 2,
		enabled: true,
		label: 'London Central',
		labelExtra: 'Gloucester Street (WC1N)',
		cost: 21.0,
		variablePrice: false,
		perks: [0, 1, 2, 3, 4, 5],
	},
	{
		id: 3,
		orderIndex: 3,
		enabled: true,
		label: 'London South',
		labelExtra: 'Wimbledon (SW19)',
		cost: 24.0,
		variablePrice: false,
		perks: [0, 1, 2, 3, 4],
	},
	{
		id: 4,
		orderIndex: 4,
		enabled: true,
		label: 'Westminster',
		labelExtra: 'Regent Street (W1)',
		cost: 42.0,
		variablePrice: false,
		perks: [0, 1, 2, 3, 4],
	},
	{
		id: 5,
		orderIndex: 5,
		enabled: true,
		label: 'Westminster',
		labelExtra: 'York Street (W1)',
		cost: 42.0,
		variablePrice: false,
		perks: [0, 1, 2, 3, 4],
	},
];

export const BusinessAddressesOverview: Array<SignUpPlanType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'Dorset',
		labelExtra: 'Poole (BH16)',
		cost: 12.0,
		variablePrice: false,
		perks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'London North',
		labelExtra: 'Palmers Green (N13)',
		cost: 18.0,
		variablePrice: false,
		perks: [0, 1, 2, 3, 4, 5],
	},
];

export const LettersOverview: Array<SignUpLetterPlanType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'Letter PAYG',
		value: 0,
		cost: 0.0,
		variablePrice: false,
		perks: [1, 2],
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'Letter 10',
		value: 10,
		cost: 9.0,
		variablePrice: false,
		perks: [0, 3],
	},
	{
		id: 2,
		orderIndex: 2,
		enabled: true,
		label: 'Letter 25',
		value: 25,
		cost: 12.0,
		variablePrice: false,
		perks: [0, 4],
	},
	{
		id: 3,
		orderIndex: 3,
		enabled: true,
		label: 'Letter 50',
		value: 50,
		cost: 21.0,
		variablePrice: false,
		perks: [0, 5],
	},
	{
		id: 4,
		orderIndex: 4,
		enabled: true,
		label: 'Letter 100',
		value: 100,
		cost: 36.0,
		variablePrice: false,
		perks: [0, 6],
	},
	{
		id: 5,
		orderIndex: 5,
		enabled: true,
		label: 'Letter 250',
		value: 250,
		cost: 87.0,
		variablePrice: false,
		perks: [0, 7],
	},
	{
		id: 6,
		orderIndex: 6,
		enabled: true,
		label: 'Letter 500',
		value: 500,
		cost: 168.0,
		variablePrice: false,
		perks: [0, 8],
	},
	{
		id: 7,
		orderIndex: 7,
		enabled: true,
		label: 'Letter 1000',
		value: 1000,
		cost: 312.0,
		variablePrice: false,
		perks: [0, 9],
	},
	{
		id: 8,
		orderIndex: 8,
		enabled: true,
		label: 'Letter 2500',
		value: 2500,
		cost: 810.0,
		variablePrice: false,
		perks: [0, 10],
	},
	{
		id: 9,
		orderIndex: 9,
		enabled: true,
		label: 'Letter 5000',
		value: 5000,
		cost: 1200.0,
		variablePrice: false,
		perks: [0, 11],
	},
];

export const ParcelsOverview: Array<SignUpParcelPlanType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'Parcel PAYG',
		cost: 0.0,
		variablePrice: false,
		perks: [0],
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'Parcel 5',
		cost: 24.0,
		variablePrice: false,
		perks: [1],
	},
	{
		id: 2,
		orderIndex: 2,
		enabled: true,
		label: 'Parcel 10',
		cost: 42.0,
		variablePrice: false,
		perks: [2],
	},
	{
		id: 3,
		orderIndex: 3,
		enabled: true,
		label: 'Parcel 25',
		cost: 84.0,
		variablePrice: false,
		perks: [3],
	},
	{
		id: 4,
		orderIndex: 4,
		enabled: true,
		label: 'Parcel 50',
		cost: 120.0,
		variablePrice: false,
		perks: [4],
	},
];

export const LetterPerks: Array<SignUpPerkType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'Unlimited Envelope Scans',
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'Receive Letters - £1.20 each',
	},
	{
		id: 2,
		orderIndex: 2,
		enabled: true,
		label: 'Page Scans £1.20 Each',
	},
	{
		id: 3,
		orderIndex: 3,
		enabled: true,
		label: '10 x Page Scans (£0.90 per item after)',
	},
	{
		id: 4,
		orderIndex: 4,
		enabled: true,
		label: '25 x Page Scans (£0.48 per item after)',
	},
	{
		id: 5,
		orderIndex: 5,
		enabled: true,
		label: '50 x Page Scans (£0.42 per item after)',
	},
	{
		id: 6,
		orderIndex: 6,
		enabled: true,
		label: '100 x Page Scans (£0.36 per item after)',
	},
	{
		id: 7,
		orderIndex: 7,
		enabled: true,
		label: '250 x Page Scans (£0.35 per item after)',
	},
	{
		id: 8,
		orderIndex: 8,
		enabled: true,
		label: '500 x Page Scans (£0.34 per item after)',
	},
	{
		id: 9,
		orderIndex: 9,
		enabled: true,
		label: '1000 x Page Scans (£0.30 per item after)',
	},
	{
		id: 10,
		orderIndex: 10,
		enabled: true,
		label: '2500 x Page Scans (£0.28 per item after)',
	},
	{
		id: 11,
		orderIndex: 11,
		enabled: true,
		label: '5000 x Page Scans (£0.24 per item after)',
	},
];

export const ParcelPerks: Array<SignUpPerkType> = [
	{
		id: 0,
		orderIndex: 0,
		enabled: true,
		label: 'Receive Parcel - £6.00 each',
	},
	{
		id: 1,
		orderIndex: 1,
		enabled: true,
		label: 'Receive 5 Parcels (£4.80 per item after)',
	},
	{
		id: 2,
		orderIndex: 2,
		enabled: true,
		label: 'Receive 10 Parcels (£4.20 per item after)',
	},
	{
		id: 3,
		orderIndex: 3,
		enabled: true,
		label: 'Receive 25 Parcels (£3.36 per item after)',
	},
	{
		id: 4,
		orderIndex: 4,
		enabled: true,
		label: 'Receive 50 Parcels (£2.40 per item after)',
	},
];

export const AddressExamples: Array<any> = [
	{
		value: 0,
		label: '1 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '1',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 1,
		label: '2 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '2',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 2,
		label: '3 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '3',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 3,
		label: '4 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '4',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 4,
		label: '5 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '5',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 5,
		label: '6 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '6',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 6,
		label: '7 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '7',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 7,
		label: '8 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '8',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 8,
		label: '9 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '9',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 9,
		label: '10 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '10',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 10,
		label: '11 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '11',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 11,
		label: '12 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '12',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 12,
		label: '13 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '13',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 13,
		label: '14 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '14',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 14,
		label: '15 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '15',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 15,
		label: '16 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '16',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 16,
		label: '17 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '17',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 17,
		label: '18 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '18',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 18,
		label: '19 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '19',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 19,
		label: '20 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '20',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
	{
		value: 20,
		label: '21 Shelley Close, Yeovil, Somerset, BA213TX, GB',
		propertyNameNumber: '21',
		street: 'Shelley Close',
		townCity: 'Yeovil',
		county: 'Somerset',
		postCode: 'BA213TX',
		countryCode: 'GB',
	},
];
